<template>
  <MediaLayout :title="title" :can-continue="canContinue" @continue="$emit('continue')">
    <component
      :is="media.Component"
      :url="url"
      :question="question"
      data-test-id="MediaLayout_Player"
      @ended="$emit('played')"
    />
    <template #button>
      {{ c('continue_to_question') }}
    </template>
  </MediaLayout>
</template>

<script lang="ts">
import { isUndefined } from 'ramda-adjunct'
import { computed, defineComponent, type PropType } from 'vue'

import MediaImageViewer from '../../../core/components/dumb/MediaImageViewer.vue'
import MediaLayout from '../../../core/components/dumb/MediaLayout.vue'
import { c } from '../../../intl'
import type { Question } from '../../models/Question'

import QuestionMediaAudioPlayer from './QuestionMediaAudioPlayer.vue'
import QuestionMediaVideoPlayer from './QuestionMediaVideoPlayer.vue'

const MEDIA = {
  video: {
    Component: QuestionMediaVideoPlayer,
  },
  audio: {
    Component: QuestionMediaAudioPlayer,
  },
  image: {
    Component: MediaImageViewer,
  },
  mux: {
    Component: QuestionMediaVideoPlayer,
  },
}

export default defineComponent({
  components: { MediaLayout, QuestionMediaVideoPlayer, QuestionMediaAudioPlayer },
  props: {
    canContinue: {
      type: Boolean,
      default: false,
    },
    question: {
      required: true,
      type: Object as PropType<Pick<Question, 'media'>>,
    },
  },
  emits: {
    continue: () => true,
    played: () => true,
  },
  setup(props) {
    const mediaType = computed(() => {
      if (isUndefined(props.question.media)) {
        throw new Error('expect currentQuestion.media to be defined')
      }
      return props.question.media.type
    })
    const title =
      mediaType.value === 'video' || mediaType.value === 'mux'
        ? c('video.please_watch_video')
        : mediaType.value === 'image'
          ? c('image_view')
          : undefined

    return {
      media: computed(() => MEDIA[mediaType.value]),
      url: computed(() =>
        props.question.media?.type === 'image' ? (props.question.media?.url ?? '') : undefined,
      ),
      title,
      c,
    }
  },
})
</script>
